const BUILD_NUMBER_KEY = 'buildNumber';

export default BUILD_NUMBER_KEY;
